import { programmaticWallpaper } from "./custom-needs";

function wallpaperStyles(isProgrammaticWallpaper?: boolean): void {
  const cssStyle =
    "position:absolute;margin-top:184px;width:1600px;left:50%;margin-left:-800px;";
  const wallpaperE = window.top.document.getElementById("almad-wallpaper-1");
  if (wallpaperE) {
    wallpaperE.style.cssText = cssStyle;
  }

  if (isProgrammaticWallpaper === true) {
    programmaticWallpaper();
  }
}

export {
  // eslint-disable-next-line import/prefer-default-export
  wallpaperStyles,
};
